/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import { Row, Col, Button, Form } from "react-bootstrap";
import FadeIn from "../../common/FadeIn";
import DateTimePicker from "react-datetime-picker";
//TimeRendering
import Moment from "react-moment";
//Images and Icons
import { MdDeleteForever } from "react-icons/md";

const CreateBlockForm = (props) => {
  //Grab the relevant VenueID and Name from props
  const venueID = props.venueID;
  //Manage States
  const [Dates, setDates] = useState([]);
  const [displayDate, setDisplayDate] = useState("");
  const [MaxLearners, setMaxLearners] = useState("");
  const [Price, setPrice] = useState("");
  const [UpperAgeString, setUpperAgeString] = useState("");
  const [LowerAgeString, setLowerAgeString] = useState("");
  const [ShortDescription, setShortDescription] = useState("");
  const [LessonType, setLessonType] = useState("");
  const [SelectedClassType, setSelectedClassType] = useState("");
  const [GradingList, setGradingList] = useState([]);
  const [isHiddenFromSchedule, setIsHiddenFromSchedule] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [Prorate, setProrate] = useState("");
  const [Duration, setDuration] = useState("");
  // Handle Click State
  const [submitClicked, setSubmitClicked] = useState(false);

  //Get Class Types from Props
  const classTypes = props.classTypes;

  // Populate the Class Type Data
  const onClassTypeChange = async (e) => {
    const selectedID = e.target.value;
    setSelectedClassType(selectedID);
    //Filter to the Class Types specific info
    const selectedTypeData = await classTypes.find((x) => x._id === selectedID);
    //Set the relevant info
    setUpperAgeString(selectedTypeData.UpperAgeString);
    setLowerAgeString(selectedTypeData.LowerAgeString);
    setShortDescription(selectedTypeData.ShortDescription);
    setLessonType(selectedTypeData.Type);
    setGradingList(selectedTypeData.GradingList);
  };

  const submitNewBlock = async (e) => {
    e.preventDefault();
    // If no dates entered, error
    if (Dates.length === 0) {
      props.scrollSmoothHandler();
      setSubmitClicked(false);
      return props.setErrorMessage("You have entered no dates.");
    }
    //Set Submit Click
    setSubmitClicked(true);
    //Build the Data
    const data = {
      blockData: {
        LessonType,
        ShortDescription,
        LowerAgeString,
        UpperAgeString,
        GradingList,
        MaxLearners,
        Price,
        isHiddenFromSchedule,
        Dates,
        EndDate,
        Duration,
        Prorate,
      },
      venueID,
    };
    // Make the API Request
    const classCreateRequest = await axios.post(`/api/admin/manage_prices/create_block/`, data, {
      withCredentials: true,
    });
    // Handle Success and failure.
    if (classCreateRequest.status === 200) {
      props.scrollSmoothHandler();
      setSubmitClicked(false);
      props.fetchNewData();
      return props.setSuccessMessage("Class was successfully created.");
    } else {
      props.scrollSmoothHandler();
      setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  const addDate = (e) => {
    e.preventDefault();
    return setDates(Dates.concat(displayDate));
  };

  //Remove a grading criteria
  const removeDate = (e, index) => {
    e.preventDefault();
    const newDateList = [...Dates];
    if (index !== -1) {
      newDateList.splice(index, 1);
      setDates(newDateList);
    }
  };

  return (
    <Row className='mt-4'>
      <FadeIn delay={250} duration={450}>
        <Form onSubmit={submitNewBlock} className='p-4 shadow'>
          <Row>
          <h4 className='text-center mb-3'>Create Block Booking</h4>
            <Col sm='3' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='SelectCustomForm'>
                <Form.Label>Choose Class Type</Form.Label>
                <Form.Control
                  as='select'
                  value={SelectedClassType}
                  onChange={onClassTypeChange}
                  required
                  custom
                  className='border'
                >
                  <option value='' disabled defaultValue>
                    Select your option
                  </option>
                  {classTypes.map((ClassType) => (
                    <option key={ClassType._id} value={ClassType._id}>
                      {ClassType.Type}
                    </option>
                  ))}
                </Form.Control>
                <Form.Text className='text-muted'>
                  The type of lesson this is - if none, go set them up in Class Types.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm='3' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='SelectCustomFormHidden'>
                <Form.Label>Public/Hidden</Form.Label>
                <Form.Control
                  as='select'
                  value={isHiddenFromSchedule}
                  onChange={(e) => setIsHiddenFromSchedule(e.target.value)}
                  required
                  custom
                  className='border'
                >
                  <option value='' disabled defaultValue>
                    Select your option
                  </option>
                  <option value='public'>On Public Schedule</option>
                  <option value='hidden'>Hidden From Schedule</option>
                </Form.Control>
                <Form.Text className='text-muted'>
                  Hidden classes do not show on the public schedule but can be linked.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm='3' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='SelectCustomFormHidden'>
                <Form.Label>Proration</Form.Label>
                <Form.Control
                  as='select'
                  value={Prorate}
                  onChange={(e) => setProrate(e.target.value)}
                  required
                  custom
                  className='border'
                >
                  <option value='' disabled defaultValue>
                    Select your option
                  </option>
                  <option value={true}>On</option>
                  <option value={false}>Off</option>
                </Form.Control>
                <Form.Text className='text-muted'>
                  Automatic covering payments. Consult signaclass docs for full explanation.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm='3' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='SelectCustomFormHidden'>
                <Form.Label>Duration</Form.Label>
                <Form.Control
                  type='number'
                  min='0'
                  max='10080'
                  value={Duration}
                  onChange={(e) => setDuration(e.target.value)}
                  required
                  className='border'
                />
                <Form.Text className='text-muted'>Block duration in minutes. Will be displayed for customers.</Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm='4' className='mt-2  pl-3 pr-3'>
              <Form.Group className='pr-4' controlId='EndTimeForm'>
                <Form.Label>Cut-Off Date</Form.Label>
                <Form.Control
                  type='date'
                  value={EndDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  required
                  className='border'
                />
                <Form.Text className='text-muted'>The final date for bookings. Blocks will not show on the schedule from this date.</Form.Text>
              </Form.Group>
            </Col>
            <Col sm='4' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='CapacityForm'>
                <Form.Label>Capacity</Form.Label>
                <Form.Control
                  type='number'
                  min='0'
                  max='100'
                  value={MaxLearners}
                  onChange={(e) => setMaxLearners(e.target.value)}
                  required
                  className='border'
                />
                <Form.Text className='text-muted'>
                  The maximum number of participants for this session.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm='4' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='PriceForm'>
                <Form.Label>Price / Full</Form.Label>
                <Form.Control
                  type='number'
                  min='0'
                  max='1000'
                  step='0.01'
                  placeholder='10.50'
                  value={Price}
                  onChange={(e) => setPrice(e.target.value)}
                  required
                  className='border'
                />
                <Form.Text className='text-muted'>
                  The total price to be rendered in your currency for all dates.
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col className='mt-2 text-center'>
              <hr />
              <h5>Enter Dates</h5>
              <div className='pb-2 pt-2'>
                {Dates.map((date, index) => (
                  <span
                    className='me-2 text-center shadow border p-1 mt-1 d-block d-md-inline-block'
                    key={index}
                    onClick={(e) => removeDate(e, index)}
                  >
                    <Moment format='ddd DD MMMM, h:mm A'>{date}</Moment> <MdDeleteForever />
                  </span>
                ))}
              </div>
              <DateTimePicker value={displayDate} onChange={(date) => setDisplayDate(date)} />
              <br />
              <Button
                className='mb-3 mt-3'
                variant='primary'
                size='info'
                type='button'
                onClick={(e) => addDate(e)}
              >
                Add Date
              </Button>
             
            </Col>
            <hr />
          </Row>
          <Row>
            <Col className='mt-2 text-center'>
              <Button
                className='mb-3'
                variant='primary'
                size='lg'
                type='submit'
                disabled={submitClicked}
              >
                Create Block Booking
              </Button>
            </Col>
          </Row>
        </Form>
      </FadeIn>
    </Row>
  );
};

export default CreateBlockForm;
